export enum PoleStatus {
    Pending = 1,
    Complete = 2,
    Incomplete = 3,
    Assigned = 4,
    Rejected = 5,
    Retagged = 6,
}
